const hasSlider = state => state.hasSlider;
const sliderImages = state => state.sliderContent.images;
const sliderType = state => state.sliderContent.type;
const activeSlideID = state => state.activeSlideID;
const sliderActive = state => state.sliderActive;

export default {
    hasSlider,
    sliderImages,
    sliderType,
    activeSlideID,
    sliderActive
};


// WEBPACK FOOTER //
// ./src/store/slider/getters.js